module.exports = __webpack_public_path__ + "static/img/business13.8a7488e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business13.jpg
// module id = OiRV
// module chunks = 9